import { render, staticRenderFns } from "./MoreCriterias.vue?vue&type=template&id=76484909&lang=pug&"
import script from "./MoreCriterias.vue?vue&type=script&lang=js&"
export * from "./MoreCriterias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports